import {
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Switch,
  Table,
} from '@material-ui/core';
import VisibilityIcon from '@material-ui/icons/Visibility';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import EditIcon from '@material-ui/icons/Edit';
import React, { useEffect, useState } from 'react';
import './charitiesTableStyles.css';
import PaginationTable from '../../paginationTable';
import { Coupon, CouponTypes } from '../../../../types/coupons';
import { getCouponStatus } from '../../../../helpers/getCouponStatus';
import { getDate } from '../../../../helpers/dateHelper';
import HeadTable from '../../sortTable/sortTable';
import TablesSearch from '../../tablesSearch/tablesSearch';
import CheckBoxesFilter from '../../checkboxFilter';
import DateFilter from '../../../users/DateFilter';
import { FilterDate } from '../../../../types/commonForm';
import { Charity } from '../../../../types/charities';
import {
  getCharitiesPageCharityStatus,
  getCharityStatus,
  getCheckoutCharityStatus,
} from '../../../../helpers/getCharityStatus';

interface Props {
  charities: Array<Charity>;
  tableComponentScope: 'general' | 'userMenengment';
  handleChangeCharityStatus?: (
    charityId: string | undefined,
    type: string
  ) => void;
  handleShowChangeStatusPopup: (charity: Charity) => void;
  page: number;
  perPage: number;
  collectionLength: number;
  total: number;
  isView: boolean;
  handleShowViewModal: (couponId: string | undefined) => void;
  handleShowEditModal?: (couponId: string | undefined) => void;
  handleShowDeleteModal: (couponId: string | undefined) => void;
  handleChangePage: (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => void;
  handleLastPage: () => void;
  handleChangeRowsPerPage: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleFirstPage: () => void;
  handleSort: (direction: string, title: string) => void;
  applySearch: (field: string) => void;
  typeFilterValues: any;
  statusFilterValues: any;
  checkTypesFilter: (event: React.ChangeEvent<HTMLInputElement>) => void;
  checkStatusFilter: (event: React.ChangeEvent<HTMLInputElement>) => void;
  applyStatusFilter: () => void;
  applyTypeFilter: () => void;
  clearTypeFilter: () => void;
  clearStatusFilter: () => void;
  startDate: FilterDate;
  finishDate: FilterDate;
  setStartStartDate: (value: Date) => void;
  setStartEndDate: (value: Date) => void;
  setEndStartDate: (value: Date) => void;
  setEndEndDate: (value: Date) => void;
  applyDateFilter: () => void;
  clearStartDateFilter: () => void;
  clearEndDateFilter: () => void;
  search: (value: string, field: string) => void;
  clearSearch: (field: string) => void;
  searchValue: string;
}
export const CharitiesTable = ({
  charities,
  page,
  perPage,
  collectionLength,
  total,
  tableComponentScope,
  handleShowViewModal,
  handleChangeCharityStatus,
  handleShowChangeStatusPopup,
  handleChangePage,
  handleLastPage,
  handleChangeRowsPerPage,
  handleFirstPage,
  handleShowEditModal,
  handleShowDeleteModal,
  isView,
  handleSort,
  applySearch,
  typeFilterValues,
  statusFilterValues,
  checkTypesFilter,
  checkStatusFilter,
  applyStatusFilter,
  applyTypeFilter,
  clearTypeFilter,
  clearStatusFilter,
  startDate,
  finishDate,
  setStartStartDate,
  setStartEndDate,
  setEndStartDate,
  setEndEndDate,
  clearStartDateFilter,
  applyDateFilter,
  clearEndDateFilter,
  search,
  clearSearch,
  searchValue,
}: Props) => {
  const [dropdown, setDropdown] = useState({
    name: false,
    type: false,
    status: false,
    start: false,
    finish: false,
  });

  const filterDropdown = (title: string) => {
    setDropdown({ ...dropdown, [title]: !dropdown[title] });
  };

  const closeFilter = () => {
    setDropdown({
      name: false,
      type: false,
      status: false,
      start: false,
      finish: false,
    });
  };

  return (
    <>
      <TableContainer className='couponTableWrapper'>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell key={1}>
                <HeadTable
                  title='Name'
                  sort={(direction, field) => handleSort(direction, 'name')}
                  filterHandle={() => filterDropdown('name')}
                />
                {dropdown.name && (
                  <TablesSearch
                    search={(event) =>
                      search(event.currentTarget.value, 'name')
                    }
                    applySearch={() => applySearch('name')}
                    searchString={searchValue}
                    clearSearch={() => clearSearch('name')}
                  />
                )}
              </TableCell>
              <TableCell>Landing URL</TableCell>
              {tableComponentScope === 'general' && (
                <TableCell className='status-column'>
                  Show on charity page
                </TableCell>
              )}
              {tableComponentScope === 'general' && (
                <TableCell className='status-column'>
                  Show on checkout page
                </TableCell>
              )}
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody onClick={closeFilter}>
            {charities.length > 0 &&
              charities.map((charity) => {
                let charitiesPageCharityStatus =
                  getCharitiesPageCharityStatus(charity);
                let checkoutCharityStatus = getCheckoutCharityStatus(charity);
                return (
                  <TableRow key={charity._id}>
                    <TableCell>{charity.name}</TableCell>
                    <TableCell>
                      {charity.landingUrl ? charity.landingUrl : '-'}
                    </TableCell>
                    {tableComponentScope === 'general' && (
                      <TableCell>
                        {charitiesPageCharityStatus.type === 'string' ? (
                          `${charitiesPageCharityStatus.value}`
                        ) : (
                          <Switch
                            checked={charity.isActiveOnCharityPage}
                            onChange={() =>
                              handleChangeCharityStatus!(
                                charity._id,
                                'charity-page'
                              )
                            }
                            color='primary'
                            name='checkedB'
                            inputProps={{ 'aria-label': 'primary checkbox' }}
                          />
                        )}
                        {/* {tableComponentScope === "userMenengment" && coupon.status ? (
                        `${coupon.status === CouponStatus.Used ? "Used" : coupon.status === CouponStatus.In_Process ? "In Process" : ''}`
                      ) : null} */}
                      </TableCell>
                    )}
                    {tableComponentScope === 'general' && (
                      <TableCell>
                        {checkoutCharityStatus.type === 'string' ? (
                          `${checkoutCharityStatus.value}`
                        ) : (
                          <Switch
                            checked={charity.isActiveOnCheckoutPage}
                            onChange={() =>
                              handleShowChangeStatusPopup(charity)
                            }
                            // onChange={() =>
                            //   handleChangeCharityStatus!(
                            //     charity._id,
                            //     'checkout-page'
                            //   )
                            // }
                            color='primary'
                            name='checkedB'
                            inputProps={{ 'aria-label': 'primary checkbox' }}
                          />
                        )}
                        {/* {tableComponentScope === "userMenengment" && coupon.status ? (
                        `${coupon.status === CouponStatus.Used ? "Used" : coupon.status === CouponStatus.In_Process ? "In Process" : ''}`
                      ) : null} */}
                      </TableCell>
                    )}
                    <TableCell className='actions-table-cell'>
                      <div className='actions-table-body'>
                        <VisibilityIcon
                          onClick={() => handleShowViewModal(charity._id)}
                          id='show-tickets'
                        />
                        {tableComponentScope === 'general' ? (
                          <div
                            onClick={() => handleShowEditModal!(charity._id)}
                          >
                            <EditIcon className='delete-icon' />
                          </div>
                        ) : null}
                      </div>
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <PaginationTable
        page={page}
        perPage={perPage}
        collectionLength={collectionLength}
        total={total}
        handleChangePage={handleChangePage}
        handleLastPage={handleLastPage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        handleFirstPage={handleFirstPage}
        title='Charities'
      />
    </>
  );
};
